import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormats } from '@shared/enums/date-time-formates.enum';
import moment, { Moment } from 'moment';

type DateFormatType = 'short' | 'long' | 'longChar' | 'nthOfMonth' | 'monthYear' | 'shortMonthYear';

@Pipe({ name: 'dateFormat', pure: true, standalone: true })
export class DateFormatPipe implements PipeTransform {
  transform(dateInput: string | Moment, format: DateFormatType = 'long'): string {
    dateInput = this.momentify(dateInput);
    if (dateInput == null || !dateInput.isValid()) {
      return '';
    }
    switch (format) {
      case 'short':
        return dateInput.format(DateTimeFormats.DDMMYY_SLASH);
      case 'longChar':
        return dateInput.format(DateTimeFormats.DDMMMMYYYY_SPACE);
      case 'nthOfMonth':
        return dateInput.format(DateTimeFormats.NTH_OF_MONTH);
      case 'monthYear':
        return dateInput.format(DateTimeFormats.MMMMYYYY_SPACE);
      case 'shortMonthYear':
        return dateInput.format(DateTimeFormats.MMYYYY_SLASH);
      default:
        return dateInput.format(DateTimeFormats.ddMMYYYY_SLASH);
    }
  }

  /**
   * Useful to safely convert string | Moment into Moment
   * @returns new Moment, or null if date parameter can't be converted to valid Moment object
   * @param date
   * @param format
   */
  momentify(date: string | moment.Moment, format?: moment.MomentFormatSpecification): moment.Moment {
    if (date == null) {
      return null;
    }
    const newDate = format ? moment(date) : moment(date, format);
    return newDate.isValid() ? newDate : null;
  }
}
